import React from 'react';
import { useSelector } from 'react-redux';

import ColorPopupContent from '../../colorTools/popup/ColorPopupContent';
import { COLOR_POPUP_MODE } from '../../colorTools/popup/colorPopupConstants';
import currentBoardSuggestedColorSelectorOnlyColors from '../../colorTools/currentBoardSuggestedColorsSelector';
import { DEFAULT_LABEL_COLORS } from '../../../../../../../common/colors/colorConstants';

type LabelColorPickerProps = {
    selectedColor: string | null;
    selectedColorHex?: string | null;
    openCustomColorPicker: () => void;
    handleColorChange: (color: string | null) => void;
};

/**
 * Shared label color picker used by the label edit sheet and the label actions popover.
 */
const LabelColorPicker: React.FC<LabelColorPickerProps> = ({
    selectedColor,
    selectedColorHex,
    handleColorChange,
    openCustomColorPicker,
}: LabelColorPickerProps) => {
    const suggestedColors = useSelector(currentBoardSuggestedColorSelectorOnlyColors);

    return (
        <div className="LabelColorPicker">
            <ColorPopupContent
                supportBackgroundColor={false}
                supportColorBar={false}
                setColor={handleColorChange}
                selectedColor={selectedColor}
                selectedColorHex={selectedColorHex}
                colorPopupMode={COLOR_POPUP_MODE.COLOR}
                defaultColors={DEFAULT_LABEL_COLORS}
                suggestedColors={suggestedColors}
                openCustomColorPicker={openCustomColorPicker}
                supportDualColors={false}
            />
        </div>
    );
};

export default LabelColorPicker;
